<template>
  <FriedModal :closable="false" size="large">
    <template #header>
      <FriedModalHeader
        :header="$t('upload-word-document')"
        :description="$t('fill-out-word-fields')"
      />
    </template>
    <div class="word-merge-input-container">
      <FriedInput
        v-for="(field, index) in wordMergeFields"
        :key="index"
        v-model="field.value"
        class="input-missing"
        :label="field.name"
        :data-external="`word-merge-field-modal-${index}-input`"
      />
    </div>
    <template #footer>
      <FriedModalButtonsFooter>
        <FriedButton
          id="word-merge-cancel-btn"
          data-external="word-merge-field-modal-cancel-button"
          button-type="secondary"
          :disabled="loading"
          @click="$emit('cancel')"
        >
          {{ $t('cancel') }}
        </FriedButton>
        <FriedButton
          data-external="word-merge-field-modal-save-button"
          :loading="loading"
          @click="handleSave(wordMerge, wordMergeFields)"
        >
          {{ $t('save') }}
        </FriedButton>
      </FriedModalButtonsFooter>
    </template>
  </FriedModal>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import type { Ref } from 'vue';
import type { WordMergeField } from '../../../../../api/word/types/word-merge-field';
import type { WordMerge } from '../../../../../document-edit/assembler/types/word-merge';

const props = defineProps<{ wordMerge: WordMerge }>();
const emit = defineEmits<{
  cancel: [];
  save: [{ missing: WordMergeField[]; name: string; pageIndex: number }];
}>();
const wordMergeFields: Ref<WordMergeField[]> = ref([]);
const loading = ref(false);

const handleSave = (wordMerge: WordMerge, wordMergeFields: WordMergeField[]) => {
  loading.value = true;
  emit('save', {
    missing: wordMergeFields,
    name: wordMerge.filename,
    pageIndex: wordMerge.index,
  });
};

onMounted(() => {
  wordMergeFields.value = props.wordMerge.missing.map((missingInput: string) => ({
    name: missingInput,
    value: '',
  }));
});
</script>
<style lang="scss" scoped>
.word-merge-input-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--spacing-50);
}
</style>
